import React from 'react';
import useSessionStoreContext from '../Contexts/SessionStoreContextProvider/useSessionStoreContext';
import { isReloadWebAppMessage } from '../Contexts/WebsocketConnectionProviders/WebsocketApiConnectionContext/types';
import useWebsocketApiConnectionContext from '../Contexts/WebsocketConnectionProviders/WebsocketApiConnectionContext/useWebsocketApiConnectionContext';

export default function useHandleAppReloadMessage() {
  const { lastJsonMessage } = useWebsocketApiConnectionContext();
  const { sessionId: [sessionId] } = useSessionStoreContext();
  const sessionIdRef = React.useRef(sessionId);
  const [shouldReload, setShouldReload] = React.useState(false);

  React.useEffect(() => {
    sessionIdRef.current = sessionId;
    if (shouldReload && !sessionId) {
      window.location.reload();
    }
  }, [sessionId, shouldReload]);

  React.useEffect(() => {
    if (isReloadWebAppMessage(lastJsonMessage)) {
      if (!sessionIdRef.current || lastJsonMessage.force) {
        window.location.reload();
      } else {
        setShouldReload(true);
      }
    }
  }, [lastJsonMessage]);
}
